import type { ColumnWidth, WidthObject } from './types';

export const isWidthObject = (
  width: ColumnWidth | WidthObject | undefined,
): width is WidthObject => {
  return typeof width === 'object' && width?.desktop !== undefined && width?.mobile !== undefined;
};
